import classnames from 'classnames'
import * as React from 'react'
import ClickOutside from 'react-click-outside'
import { ChromePicker } from 'react-color'
import {FormGroup, Label} from 'reactstrap'
import './styles.css'

export interface Color {
  hex: string,
  hsl: { [key: string]: number },
  hsv: { [key: string]: number },
  oldHue: number,
  rgb: { [key: string]: number },
  source: string,
}

interface ComponentProp { handleChange: any }

interface Props {
  color: string,
  defaultColor?: string,
  disabled?: boolean,
  handleChange: ComponentProp,
  label: string,
}

interface State { isOpen: boolean }

export class RasaChromePicker extends React.Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isOpen: false }
  }
  public toggle = () => this.setState({ isOpen: !this.state.isOpen })
  public close = () => this.setState({ isOpen: false })
  public render() {
    return (
      <ClickOutside onClickOutside={this.close} >
        <div className={classnames('rasa-input rasa-chrome-picker',
          {'rasa-chrome-picker-disabled': this.props.disabled})}>
          {this.props.label && <Label className="field-label">
            <span className="field-label-text rasa-chrome-picker-label">{this.props.label}</span></Label>}
          <FormGroup onClick={this.toggle}
            className={classnames('field-input rasa-chrome-picker-input',
              {'rasa-chrome-picker-disabled': this.props.disabled})}>
              <button style={{ background: `${this.props.color || this.props.defaultColor}` }}
                className={classnames('rasa-chrome-picker-color-box',
                  {'rasa-chrome-picker-disabled': this.props.disabled})} />
              <span className="rasa-chrome-picker-hex">{this.props.color}</span>
          </FormGroup>
          {!this.props.disabled && this.state.isOpen &&
            <div className="block-container">
              <ChromePicker
                disableAlpha
                color={this.props.color || this.props.defaultColor}
                onChangeComplete={this.props.handleChange} />
            </div>
          }
        </div>
      </ClickOutside>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/chrome-picker/rasa-chrome-picker.tsx